// import Moment from 'moment';
import Vue from 'vue';

export default {
  methods: {
    // 时间范围数组解析为Begin、End结尾的单个字段，并删除数组的字段
    parseRangeDate(paramsData = {}, fields = [], suffixs = [], encode = true) {
      const oldData = JSON.parse(JSON.stringify(paramsData));
      const newData = JSON.parse(JSON.stringify(paramsData));
      const filterRangeDate = fields.filter((name) => oldData[name] && oldData[name].every((val) => val)); // ['开始时间','结束时间']不为空
      function before(startFormat = '%F %T', endFormat = startFormat) {
        filterRangeDate.forEach((field) => {
          suffixs
            .map((rangeName) => `${rangeName}${field.replace(/^([a-z])/, (reg) => reg.toUpperCase())}`)
            .forEach((rangeName, index) => {
              // newData[rangeName] = Moment(new Date(oldData[field][index]).getTime()).format('YYYY-MM-DD hh:mm:ss');
              newData[rangeName] = Vue.filter('date')(new Date(oldData[field][index]).getTime(), index ? endFormat : startFormat);
              if (encode === true) {
                newData[rangeName] = encodeURIComponent(newData[rangeName]);
              }
            });
          delete newData[field];
        });
        return newData;
      }
      function after(startFormat = '%F %T', endFormat = startFormat) {
        filterRangeDate.forEach((field) => {
          suffixs
            .map((rangeName) => `${field}${rangeName}`)
            .forEach((rangeName, index) => {
              // newData[rangeName] = Moment(new Date(oldData[field][index]).getTime()).format('YYYY-MM-DD hh:mm:ss');
              newData[rangeName] = Vue.filter('date')(new Date(oldData[field][index]).getTime(), index ? endFormat : startFormat);
              if (encode === true) {
                newData[rangeName] = encodeURIComponent(newData[rangeName]);
              }
            });
          delete newData[field];
        });
        return newData;
      }

      return {
        before,
        after,
      };
    },
  },
};
